import { cn } from "@web/lib/utils";
import markDark from "../../brand/logo_mark_only.svg?url";
import markLight from "../../brand/logo_mark_only_white.svg?url";
import horizontalDark from "../../brand/logo_primary_horizontal_EN.svg?url";
import horizontalLight from "../../brand/logo_primary_horizontal_EN_white.svg?url";

/**
 * SHEN NONG SHI logo. Scale only; never recolor or distort (brand manual).
 * Black lockup on light backgrounds, white lockup in dark mode.
 */
export function LogoHorizontal({ className, height = 26 }: { className?: string; height?: number }) {
  const width = Math.round((height * 305.14) / 59.18);
  return (
    <span className={cn("inline-flex shrink-0", className)} style={{ height, width }}>
      <img
        src={horizontalDark}
        alt="SHEN NONG SHI"
        height={height}
        width={width}
        className="block dark:hidden"
        draggable={false}
      />
      <img
        src={horizontalLight}
        alt="SHEN NONG SHI"
        height={height}
        width={width}
        className="hidden dark:block"
        draggable={false}
      />
    </span>
  );
}

export function LogoMark({ className, height = 28 }: { className?: string; height?: number }) {
  const width = Math.round((height * 248.53) / 209.14);
  return (
    <span className={cn("inline-flex shrink-0", className)} style={{ height, width }}>
      <img
        src={markDark}
        alt="SHEN NONG SHI"
        height={height}
        width={width}
        className="block dark:hidden"
        draggable={false}
      />
      <img
        src={markLight}
        alt="SHEN NONG SHI"
        height={height}
        width={width}
        className="hidden dark:block"
        draggable={false}
      />
    </span>
  );
}

/** Company artwork only; the internal project name is not part of the site identity. */
export function Lockup({ compact = false, className }: { compact?: boolean; className?: string }) {
  return (
    <span className={cn("inline-flex items-center", className)}>
      {compact ? <LogoMark height={32} /> : <LogoHorizontal height={30} />}
    </span>
  );
}
